(function($) {
  var $images = $('.room-gallery__main img');

  var thumbSlide = new Swiper('.room-gallery__thumbnail', {
    spaceBetween: 10,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    slidesPerView: 2,
    breakpointsInverse: true,
    breakpoints: {
      375: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 5
      },
      1024: {
        slidesPerView: 7
      },
      1200: {
        slidesPerView: 8
      }
    },
  });

  var length = $images.length;
  var mainSlide = new Swiper('.room-gallery__main', {
    loop: length > 1,
    autoplay: length > 1,
    thumbs: {
      swiper: thumbSlide
    },
    navigation: {
      prevEl: '.room-gallery-prev',
      nextEl: '.room-gallery-next'
    }
  });

  $('.room-gallery-lightbox').on('click', function() {
    var images = [];

    $images.each((i, image) => {
      images[i] = {
        src: image.getAttribute('src'),
        opts: {
          thumbs: image.getAttribute('src'),
          caption: image.getAttribute('alt')
        }
      }
    })

    $.fancybox.open( images, mainSlide.realIndex );
  });

  $(window).on('load', () => {
    $('.room-item__excerpt p').each((i, el) => {
      new Dotdotdot( el, {
        height: 48,
        truncate: 'letter'
      } );
    })
  })
})(jQuery);